<template>
    <div class="new-fence">
        <div class="breadcrumb" style="font-size: 14px;">设置围栏
            <el-button class="right_f" type="primary" @click="cancel">返回</el-button>
            <el-button v-if="clearBtnShow" class="right_f" type="primary" @click="saveFence">保存</el-button>
            <el-button v-if="clearBtnShow" class="right_f" type="danger" plain @click="clearAll">清空围栏</el-button>
        </div>
        <el-form label-width="80px" :inline="true">
            <el-form-item label="围栏名称">
                <el-input v-model="name" />
            </el-form-item>
            <el-form-item label="所属跑区">
                <el-input v-model="runAreaNames" disabled />
            </el-form-item>
        </el-form>
        <div class="search-box">
            <el-input class="fence-input" v-model="schoolName" type="text" @keyup.enter.native="theLocation"
                placeholder="请输入搜索地址"></el-input>
            <el-button type="primary" @click="theLocation">搜索</el-button>
        </div>
        <div style="text-align: right;"> 提示：选取最后一个点位时，双击鼠标即可结束画图！ </div>
        <div style="position: relative;">
            <div id="my-map"></div>
            <div class="drawing-toolbar" v-if="clearBtnShow">
                <div class="toolbar-item" @click="startDrawPolygon" title="绘制多边形">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2L2 7L12 12L22 7L12 2Z"/>
                        <path d="M2 17L12 22L22 17"/>
                        <path d="M2 12L12 17L22 12"/>
                    </svg>
                    <span>绘制围栏</span>
                </div>
                <div class="toolbar-item" @click="clearAll" title="清空绘制">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"/>
                    </svg>
                    <span>清空</span>
                </div>
            </div>
        </div>

        <div class="margin-top-20 margin-bottom-20" v-if="clearBtnShow">
            <el-row :gutter="16">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                    <el-form label-position="top" :model="pointForm">
                        <el-form-item label="框定点位">
                            <div class="flex-row">
                                <el-select v-model="pointForm.tmpList" placeholder="请选择点位" filterable multiple
                                    style="flex: 1; margin-right: 8px">
                                    <el-option v-for="(item, index) in pointList" :key="index"
                                        :label="item.pointsNumber" :value="item.pid"
                                        :disabled="pointForm.selectedList.includes(item.pid)" />
                                </el-select>
                                <el-button type="primary" @click="clickAddPoint">添加</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="已框点位">
                            <div class="card-wrap">
                                <div v-for="(item, index) in pointForm.selectedOptions" :key="index"
                                    class="dialog-item">
                                    <div>{{ item.label }}</div>
                                    <el-button type="text" icon="circle-close" @click="clickDeletePoint(item)">
                                    </el-button>
                                </div>
                            </div>
                            <div class="card-footer">共{{ pointForm.selectedList.length }}个点位</div>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <div class="margin-top-20 margin-bottom-20" v-if="!clearBtnShow">
            <el-row :gutter="16">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                    <div>
                        <div class="flex-row-between">
                            <span>框定点位</span>
                            <el-button type="primary" size="small" @click="clickEditPoints()">编辑</el-button>
                        </div>
                        <div class="card-wrap">
                            <div class="card-item" v-for="(item, index) in runGeoFencePoints" :key="index">
                                {{ item.serialNum }}
                            </div>
                        </div>
                        <div class="card-footer">共{{ runGeoFencePoints.length || 0 }}个位点</div>
                    </div>
                </el-col>
            </el-row>
        </div>

        <el-dialog title="框定点位" v-model="dialogPointVisible" size="tiny" :modal-append-to-body="false">
            <el-form label-position="top" :model="pointForm">
                <el-form-item label="选择点位">
                    <div class="flex-row">
                        <el-select v-model="pointForm.tmpList" placeholder="请选择点位" filterable multiple
                            style="flex: 1; margin-right: 8px">
                            <el-option v-for="(item, index) in pointList" :key="index" :label="item.pointsNumber"
                                :value="item.pid" :disabled="pointForm.selectedList.includes(item.pid)" />
                        </el-select>
                        <el-button type="primary" @click="clickAddPoint">添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="已框点位">
                    <div class="card-wrap">
                        <div v-for="(item, index) in pointForm.selectedOptions" :key="index" class="dialog-item">
                            <div>{{ item.label }}</div>
                            <el-button type="text" icon="circle-close" @click="clickDeletePoint(item)">
                            </el-button>
                        </div>
                    </div>
                    <div class="card-footer">共{{ pointForm.selectedList.length }}个点位</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogPointVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEditUgrpids">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { baiduToAmap } from '../../../common/mapUtils.js';
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
    data() {
        return {
            runAreaNames: '',
            runGeoFencePoints: {},
            unid: '',
            name: '',
            schoolName: '',
            fenceId: '',
            clearBtnShow: false,
            map: null,
            overlays: [],
            styleOptions: {
                strokeColor: "#0398FF",
                fillColor: "#0398FF",
                strokeWeight: 3,
                strokeOpacity: 1,
                fillOpacity: 0.2,
                strokeStyle: 'solid'
            },
            pointData: [], // 当前围栏的点数据
            allFences: [], // 存储所有围栏数据的数组
            pointList: [],
            fencePointList: [],
            dialogPointVisible: false,
            pointForm: {
                tmpList: [],
                selectedList: [],
                selectedOptions: []
            },
            mouseTool: null
        }
    },
    mounted() {
        this.unid = this.$util.getUrlParam("unid");
        this.fenceId = this.$util.getUrlParam("id");
        // 使用AMapLoader.load方式加载高德地图
        AMapLoader.load({
            key: "d92371543c53fdaa3a019886ebaa015a", // 使用项目中的高德地图Key
            version: "2.0", // 指定要加载的 JS API 的版本
            plugins: ["AMap.MouseTool"] // 需要使用的插件列表
        }).then((AMap) => {
            // 地图加载成功后，获取所有点位
            this.getAllPoints();
        }).catch(e => {
            console.error('地图加载失败:', e);
            this.$util.errorMsg('地图加载失败，请刷新页面重试');
        });
    },
    methods: {
        theLocation() {
            let name = this.schoolName;
            if (!name || !name.trim()) {
                this.$util.errorMsg('请输入搜索地址');
                return;
            }
            
            // 使用高德地图Web服务API的POI搜索接口
            const webServiceKey = '4eb489b9bd72bb75eeca38a87fda119a'; // 使用Web服务Key
            const searchUrl = `https://restapi.amap.com/v5/place/text?key=${webServiceKey}&keywords=${encodeURIComponent(name)}&types=&city=&children=1&offset=20&page=1&extensions=all`;
            
            fetch(searchUrl)
                .then(response => response.json())
                .then(data => {
                    console.log('POI搜索结果:', data);
                    
                    if (data.status === '1' && data.pois && data.pois.length > 0) {
                        // 获取第一个搜索结果的坐标
                        const poi = data.pois[0];
                        const location = poi.location.split(',');
                        const lng = parseFloat(location[0]);
                        const lat = parseFloat(location[1]);
                        
                        // 设置地图中心和缩放级别
                        this.map.setCenter([lng, lat]);
                        this.map.setZoom(16);
                        this.$util.successMsg(`搜索成功：${poi.name}`);
                    } else {
                        this.$util.errorMsg('未找到该地址，请重新输入');
                    }
                })
                .catch(error => {
                    console.error('POI搜索错误:', error);
                    this.$util.errorMsg('搜索失败，请检查网络连接');
                });
        },
        // 保存围栏
        saveFence() {
            if (!this.name.trim()) {
                return this.$util.errorMsg('请填写围栏名称');
            }
            let pointData = [];
            if (this.pointData && this.pointData.length > 0) {
                this.pointData.forEach((item, index) => {
                    pointData.push({
                        lon: 0,
                        lat: 0,
                        glat: item.glat,
                        glon: item.glon,
                        pointsNumber: index + 1
                    })
                })
            }
            this.$http({
                method: 'POST',
                url: this.$util.domain + '/adminapi/v1/campus/geoFence/save',
                body: JSON.stringify({
                    name: this.name,
                    unid: this.unid,
                    points: pointData,
                    pointUgrpids: this.pointForm.selectedList,
                })
            }).then(response => {
                if (response.data.error == 10000) {
                    this.$util.successMsg('围栏保存成功！');
                    location.href = `/#/xiaoyuan/GX/runningFence?unid=${this.unid}`;
                } else {
                    this.$util.errorMsg('围栏保存失败！');
                }
            })
        },
        // 清空围栏
        clearAll() {
            // 清除高德地图上的所有覆盖物
            if (this.overlays && this.overlays.length > 0) {
                this.map.remove(this.overlays);
                this.overlays = [];
            }
            
            // 清除所有标记和多边形
            this.map.clearMap();
            
            // 重新绘制点位标记（保留原有的点位显示）
            if (this.pointList && this.pointList.length > 0) {
                this.pointList.forEach(item => {
                    const amapCoord = baiduToAmap(item.glon, item.glat);
                    
                    let iconUrl = 'https://swapp-image.gxapp.iydsj.com/admin-api/appiontP%402x.png';
                    if (item.mustThoughPoint) {
                        iconUrl = 'https://swapp-image.gxapp.iydsj.com/admin-api/appiont%402x.png'
                    }
                    
                    let marker = new AMap.Marker({
                        position: [amapCoord.lng, amapCoord.lat],
                        icon: new AMap.Icon({
                            image: iconUrl,
                            size: new AMap.Size(22, 38),
                            imageSize: new AMap.Size(22, 38)
                        }),
                        label: {
                            content: item.pointsNumber,
                            offset: new AMap.Pixel(0, -10),
                            direction: 'center'
                        }
                    });
                    
                    this.map.add(marker);
                });
            }
            
            // 清空绘制的围栏数据
            this.pointData = [];
        },

        // 获取点位
        getAllPoints() {
            this.pointList = [];
            this.$http({
                method: 'GET',
                url: this.$util.domain + '/adminapi/v1/campus/points/queryPointsInfo',
                params: { unid: this.unid }
            }).then(response => {
                if (response.data.error == 10000) {
                    this.pointList = response.data.data;
                    if (this.fenceId) {
                        this.getFenceDetail();
                    } else {
                        this.drawingMyMap();
                    }
                } else {
                    this.drawingMyMap();
                }
            }).catch(_ => {
                this.drawingMyMap();
            })
        },
        // 获取围栏信息
        getFenceDetail() {
            this.$http({
                method: 'GET',
                url: this.$util.domain + '/adminapi/v1/campus/geoFence/detail',
                params: { id: this.fenceId }
            }).then(response => {
                if (response.data.error == 10000) {
                    this.fencePointList = response.data.data.points;
                    this.name = response.data.data.name;
                    this.runAreaNames = response.data.data.runAreaNames;
                    this.runGeoFencePoints = response.data.data.runGeoFencePoints || [];
                }
                this.drawingMyMap();
            }).catch(_ => {
                this.drawingMyMap();
            })
        },
        // 保存框定点位
        saveEditUgrpids() {
            this.$http({
                method: 'POST',
                url: this.$util.domain + '/adminapi/v1/campus/geoFence/editUgrpids',
                body: JSON.stringify({
                    fenceId: this.fenceId,
                    ugrpids: this.pointForm.selectedList,
                    unid: this.unid,
                })
            }).then(response => {
                if (response.data.error == 10000) {
                    this.$util.successMsg('保存成功！');
                    this.dialogPointVisible = false;
                    this.getFenceDetail();
                } else {
                    this.$util.errorMsg('保存失败！');
                }
            })
        },
        // 初始化地图
        initMap() {
            // 创建高德地图实例
            this.map = new AMap.Map('container', {
                zoom: 13,
                mapStyle: 'amap://styles/normal'
            });

            // 初始化鼠标绘制工具
            AMap.plugin(['AMap.MouseTool'], () => {
                this.mouseTool = new AMap.MouseTool(this.map);
            });

            // 地图点击事件
            this.map.on('click', (e) => {
                this.addPoint(e.lnglat.lng, e.lnglat.lat);
            });
        },
        drawingMyMap() {
            let that = this;
            let pointList = that.pointList;
            let fencePointList = that.fencePointList;
            
            // 使用AMapLoader.load方式加载高德地图
            AMapLoader.load({
                key: "d92371543c53fdaa3a019886ebaa015a",
                version: "2.0",
                plugins: ["AMap.MouseTool"]
            }).then((AMap) => {
                // 创建高德地图实例
                let map = new AMap.Map('my-map', {
                    zoom: 16,
                    center: [116.397428, 39.90923],
                    mapStyle: 'amap://styles/normal'
                });
                
                let styleOptions = that.styleOptions;
                that.map = map;

                let poi = null;
                if (pointList && pointList.length > 0) {
                    pointList.forEach(item => {
                        // 将百度地图坐标转换为高德地图坐标
                        const amapCoord = baiduToAmap(item.glon, item.glat);
                        
                        let iconUrl = 'https://swapp-image.gxapp.iydsj.com/admin-api/appiontP%402x.png';
                        if (item.mustThoughPoint) {
                            iconUrl = 'https://swapp-image.gxapp.iydsj.com/admin-api/appiont%402x.png'
                        }
                        
                        // 创建高德地图标记
                        let marker = new AMap.Marker({
                            position: [amapCoord.lng, amapCoord.lat],
                            icon: new AMap.Icon({
                                image: iconUrl,
                                size: new AMap.Size(22, 38),
                                imageSize: new AMap.Size(22, 38)
                            }),
                            label: {
                                content: item.pointsNumber,
                                offset: new AMap.Pixel(0, -10),
                                direction: 'center'
                            }
                        });
                        
                        map.add(marker);
                    });
                    
                    // 将第一个点的坐标转换为高德地图坐标作为中心点
                    const firstPointCoord = baiduToAmap(pointList[0].glon, pointList[0].glat);
                    poi = [firstPointCoord.lng, firstPointCoord.lat];
                } else {
                    poi = [116.397428, 39.90923]; // 默认北京坐标
                }
                
                map.setCenter(poi);
                map.setZoom(16);

                // 显示围栏区域
                if (fencePointList && fencePointList.length > 0) {
                    this.clearBtnShow = false;
                    
                    // 将百度地图围栏坐标转换为高德地图坐标
                    const amapFencePoints = fencePointList.map(point => {
                        const amapCoord = baiduToAmap(point.glon, point.glat);
                        return [amapCoord.lng, amapCoord.lat];
                    });
                    
                    // 创建多边形
                    let polygon = new AMap.Polygon({
                        path: amapFencePoints,
                        strokeColor: styleOptions.strokeColor,
                        strokeWeight: styleOptions.strokeWeight,
                        strokeOpacity: styleOptions.strokeOpacity,
                        fillColor: styleOptions.fillColor,
                        fillOpacity: styleOptions.fillOpacity,
                        strokeStyle: styleOptions.strokeStyle
                    });
                    
                    map.add(polygon);
                } else {
                    that.overlays = [];
                    this.clearBtnShow = true;
                    
                    // 初始化鼠标绘制工具
                    that.mouseTool = new AMap.MouseTool(map);
                    
                    // 监听多边形绘制完成事件
                    that.mouseTool.on('draw', (e) => {
                        if (that.overlays && that.overlays.length > 0) {
                            map.remove(that.overlays[0]);
                            that.overlays.length = 0;
                        }
                        that.overlays.push(e.obj);
                        that.pointData = e.obj.getPath().map(point => ({
                            lng: 0,
                            lat: 0,
                            glon: point.lng,
                            glat: point.lat,
                        }));
                    });
                }
            }).catch(e => {
                console.error('地图加载失败:', e);
                that.$util.errorMsg('地图加载失败，请刷新页面重试');
            });
        },
        // 添加点
        addPoint(lng, lat) {
            this.pointData.push({ lng: lng, lat: lat, glon: glon, glat: glat});
            this.drawPoints();
        },
        
        // 绘制点
        drawPoints() {
            // 清除之前的标记
            this.map.clearMap();
            
            // 重新绘制所有点
            this.pointData.forEach((point, index) => {
                let marker = new AMap.Marker({
                    position: [point.lng, point.lat],
                    icon: new AMap.Icon({
                        image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
                        size: new AMap.Size(19, 31),
                        imageSize: new AMap.Size(19, 31)
                    }),
                    label: {
                        content: (index + 1).toString(),
                        offset: new AMap.Pixel(0, -10),
                        direction: 'center'
                    }
                });
                this.map.add(marker);
            });
            
            // 如果有多个点，绘制多边形
            if (this.pointData.length > 2) {
                const path = this.pointData.map(point => [point.glon, point.glat]);
                let polygon = new AMap.Polygon({
                    path: path,
                    strokeColor: this.styleOptions.strokeColor,
                    strokeWeight: this.styleOptions.strokeWeight,
                    strokeOpacity: this.styleOptions.strokeOpacity,
                    fillColor: this.styleOptions.fillColor,
                    fillOpacity: this.styleOptions.fillOpacity,
                    strokeStyle: this.styleOptions.strokeStyle
                });
                this.map.add(polygon);
            }
        },
        
        // 清除绘制
        clearDraw() {
            this.pointData = [];
            this.map.clearMap();
            this.clearBtnShow = false;
        },
        
        // 开始绘制多边形
        startDrawPolygon() {
            if (this.mouseTool) {
                this.mouseTool.polygon(this.styleOptions);
            }
        },
        
        cancel() {
            location.href = `/#/xiaoyuan/GX/runningFence?unid=${this.unid}`;
        },
        // 编辑点位
        clickEditPoints() {
            this.pointForm.selectedList = this.runGeoFencePoints.map((item) => item.ugrpid);
            this.pointForm.selectedOptions = this.runGeoFencePoints.map((item) => ({
                label: item.serialNum,
                value: item.ugrpid,
            }));
            this.pointForm.tmpList = [];
            this.dialogPointVisible = true;
        },
        // 添加点位
        clickAddPoint() {
            this.pointForm.selectedList = this.pointForm.selectedList.concat(this.pointForm.tmpList).sort();
            this.pointForm.selectedOptions = this.pointList.filter((item) => {
                return this.pointForm.selectedList.includes(item.pid)
            }).map((item) => ({
                label: item.pointsNumber,
                value: item.pid,
            }));
            this.pointForm.tmpList = [];
        },
        // 删除点位
        clickDeletePoint(point) {
            this.pointForm.selectedList = this.pointForm.selectedList.filter((item) => item !== point.value);
            this.pointForm.selectedOptions = this.pointForm.selectedOptions.filter((item) => item.value !== point.value);
        },
    }
}
</script>
<style scoped>
.new-fence {
    padding: 0 30px;
}

.new-fence #my-map {
    width: 100%;
    height: 600px;
}

.new-fence .BMapLib_Drawing_panel {
    height: 47px;
    border: 1px solid #666;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
    float: left
}

.new-fence .drawing-toolbar {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    display: flex;
    background: white;
    border: 1px solid #666;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
}

.new-fence .toolbar-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    border-right: 1px solid #d2d2d2;
    background: white;
    transition: background-color 0.2s;
}

.new-fence .toolbar-item:last-child {
    border-right: none;
}

.new-fence .toolbar-item:hover {
    background-color: #f5f5f5;
}

.new-fence .toolbar-item svg {
    margin-right: 4px;
    color: #333;
}

.new-fence .toolbar-item span {
    font-size: 12px;
    color: #333;
}

.new-fence .BMapLib_Drawing .BMapLib_box {
    border-right: 1px solid #d2d2d2;
    float: left;
    height: 100%;
    width: 64px;
    height: 100%;
    background-color: #f5f5f5;
    cursor: pointer
}

.new-fence .BMapLib_Drawing .BMapLib_last {
    border-right: 0
}

.new-fence .BMapLib_Drawing .BMapLib_hander {
    background-position: 0 0
}

.new-fence .BMapLib_Drawing .BMapLib_hander_hover {
    background-position: 0 -52px
}

.new-fence .BMapLib_Drawing .BMapLib_marker {
    background-position: -65px 0
}

.new-fence .BMapLib_Drawing .BMapLib_marker_hover {
    background-position: -65px -52px
}

.new-fence .BMapLib_Drawing .BMapLib_circle {
    background-position: -130px 0
}

.new-fence .BMapLib_Drawing .BMapLib_circle_hover {
    background-position: -130px -52px
}

.new-fence .BMapLib_Drawing .BMapLib_polyline {
    background-position: -195px 0
}

.new-fence .BMapLib_Drawing .BMapLib_polyline_hover {
    background-position: -195px -52px
}

.new-fence .BMapLib_Drawing .BMapLib_polygon {
    background-position: -260px 0
}

.new-fence .BMapLib_Drawing .BMapLib_polygon_hover {
    background-position: -260px -52px
}

.new-fence .BMapLib_Drawing .BMapLib_rectangle {
    background-position: -325px 0
}

.new-fence .BMapLib_Drawing .BMapLib_rectangle_hover {
    background-position: -325px -52px
}

.new-fence .BMapLib_Drawing .anchorBL {
    display: none !important;
}

.new-fence .clear-btn {
    position: absolute;
    right: 170px;
    top: 148px;
    height: 46px;
    z-index: 10000;
}

.new-fence .fence-input {
    display: inline-block;
    width: 300px;
}

.search-box {
    position: absolute;
    left: 120px;
    top: 148px;
    height: 46px;
    z-index: 10000;
}

.draw-tip {
    position: absolute;
    right: 60px;
    top: 108px;
    z-index: 10000;
    color: red;
}

.card-wrap {
    width: 100%;
    height: 200px;
    margin: 8px 0 4px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #c0ccda;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    overflow: auto;
}

.card-footer {
    text-align: right;
    font-size: 14px;
    line-height: 1.5;
}

.card-item {
    height: 30px;
    margin-bottom: 8px;
    margin-right: 8px;
    padding: 4px 10px;
    box-sizing: border-box;
    border: 1px solid #999;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.5;
}

.dialog-item {
    margin: 0px 8px 8px 0px;
    padding: 0px 8px;
    box-sizing: border-box;
    border: 1px solid #c0ccda;
    border-radius: 4px;
    font-size: 14px;
    line-height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}
</style>


// WEBPACK FOOTER //
// newFence.vue?6a1c66d4